import React from 'react';
import { Eye, Heart, Globe2, Mic, BookOpen } from 'lucide-react';
const reasons = [{
  icon: Eye,
  title: 'Historical facts that were silenced',
  body: "Rigorous documentation of repression, systemic corruption, and the decisions that destroyed Latin America's richest nation."
}, {
  icon: Heart,
  title: 'The humanitarian crisis from within',
  body: 'Shortages of medicine, famine, and the collapse of basic services. Not as a statistic—but as a lived human experience.'
}, {
  icon: Globe2,
  title: 'The final fall of the regime',
  body: 'A deep analysis of the political collapse, internal betrayals, and the moment the world could finally no longer look away.'
}, {
  icon: Mic,
  title: 'What the world refused to see',
  body: 'International complicity, the media that remained silent, and the governments that looked the other way while an entire people suffered.'
}, {
  icon: BookOpen,
  title: 'Deep but accessible to everyone',
  body: 'Written to be read by anyone, not just academics. A narrative that engages from the first page to the last.'
}];
function ReasonCard({
  icon: Icon,
  title,
  body
}: {
  icon: typeof Eye;
  title: string;
  body: string;
}) {
  return <div className="bg-[#111] border border-gray-800 rounded-lg p-8 hover:border-[#d4a85a]/30 transition-colors text-left h-full flex flex-col gap-4" data-id="element-262">
      <Icon className="w-7 h-7 text-[#d4a85a]" strokeWidth={1.5} data-id="element-263" />
      <h3 className="font-serif text-xl sm:text-[22px] text-[#e8e2d4] font-normal leading-snug" data-id="element-264">
        {title}
      </h3>
      <p className="text-gray-400 text-[15px] leading-relaxed font-light" data-id="element-265">
        {body}
      </p>
    </div>;
}
export function WhatYouLearn() {
  const topRow = reasons.slice(0, 3);
  const bottomRow = reasons.slice(3);
  return <section className="bg-[#0a0a0a] pb-12 sm:pb-20 px-6" data-id="element-266">
      <div className="max-w-6xl mx-auto flex flex-col gap-6" data-id="element-267">
        {/* Top row — 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-268">
          {topRow.map(r => <ReasonCard key={r.title} {...r} data-id="element-269" />)}
        </div>

        {/* Bottom row — 2 columns, centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:max-w-[66.66%] md:mx-auto w-full" data-id="element-270">
          {bottomRow.map(r => <ReasonCard key={r.title} {...r} data-id="element-271" />)}
        </div>
      </div>
    </section>;
}